import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation, useParams } from 'react-router-dom';
import { useRef, useEffect, useState } from 'react';

function MenuApartmentComponent() {
  const { t } = useTranslation();
  const location = useLocation();
  const [isScrollUp, setIsScrollUp] = useState(false);
  const prevScrollY = useRef(0);
  const { id, slug, language} = useParams();
  const searchParams = new URLSearchParams(useLocation().search);
  // const fromHome = searchParams.get('home');

  const handleBreadcrum = () => {
    let handleParamUrl = '';
    switch (true) {
      case searchParams.get('home') === 'true':
        handleParamUrl = 'home=true'
        break;
      case searchParams.get('by-property') === '1':
        handleParamUrl = 'by-property=1'
        break;
      case searchParams.get('by-map') === '1':
        handleParamUrl = 'by-map=1'
        break;
      default:
        break;
    }
    return handleParamUrl;
  }
  // const paramUrl = useMemo(() => a(), [handleParamUrl]);
  // console.log(paramUrl);
  const menuItems = [
    {
      to: `/featured-projects/detail/overview/${id}/${slug}${handleBreadcrum() ? '?' + handleBreadcrum() : ''}`,
      name: t('detailProject.overview_title'),
      active: location.pathname.includes(`/featured-projects/detail/overview`),
    },
    {
      to: `/featured-projects/detail/apartment-room-types/${id}/${slug}?${handleBreadcrum() ? handleBreadcrum() + '&': ''}pageIndex=1&pageSize=15&orderBy=desc&sortBy=0`,
      name: t('detailProject.apartment_title'),
      active: location.pathname.includes(`/featured-projects/detail/apartment-room-types`),
    },
    {
      to: `/featured-projects/detail/facilities/${id}/${slug}${handleBreadcrum() ? '?' + handleBreadcrum() : ''}`,
      name: t('detailProject.facilities_title'),
      active: location.pathname.includes(`/featured-projects/detail/facilities`),
    },
    {
      to: `/featured-projects/detail/location/${id}/${slug}${handleBreadcrum() ? '?' + handleBreadcrum() : ''}`,
      name: t('detailProject.location_title'),
      active: location.pathname.includes(`/featured-projects/detail/location`),
    },
    {
      to: `/featured-projects/detail/offer-sub/${id}/${slug}?${handleBreadcrum() ? handleBreadcrum() + '&' : ''}pageIndex=1&pageSize=10&orderBy=desc&sortBy=0`,
      name: t('detailProject.offers_title'),
      active: location.pathname.includes(`/featured-projects/detail/offer-sub`),
    },
    {
      to: `/featured-projects/detail/gallery/${id}/${slug}${handleBreadcrum() ? '?' + handleBreadcrum() : ''}`,
      name: t('detailProject.gallery_title'),
      active: location.pathname.includes(`/featured-projects/detail/gallery`),
    },
  ];

  const handleScroll = () => {
    const currentScrollY = window.scrollY;
    prevScrollY.current >= 395 ? setIsScrollUp(true) : setIsScrollUp(false)
    prevScrollY.current = currentScrollY;
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
    // eslint-disable-next-line
  }, [prevScrollY]);

  return (
    <div id="detailApartmentMenu" className={`${isScrollUp ? 'detailApartmentMenu' : 'detailApartmentMenuHide'}`}>
      <div className="container">
        <div className="row scroll-menu px-3 pb-3 pt-3">
          {menuItems.map((item, index) => {
            return (
              <Link
                key={index}
                to={`/${language}` + item.to}
                className={`menu-apartment-item right-space ${item.active ? 'active_item' : ''}`}
              >
                {item.name}
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default MenuApartmentComponent;
